import traverse from './traverse.js'

export default function next_segment($input) {
	traverse($input, 'next')
}
